<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content">
        <div class="row position-relative">
          <div class="col-12 col-md-6 col-lg-7 mt-5 mb-3 mb-md-5">
            <slot name="image-carousel"></slot>
            <div class="free-socks d-none d-md-flex p-2 mt-3" v-if="hasProp377Socks">
              <slot name="free-socks"></slot>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mt-md-5 buybox mb-md-5">
            <div>
              <!-- START SINGLEITEM_DETAILS -->

              <h1 class="h2 title" data-testing="item-name">
                <span>
                  {{ currentVariation | itemName }}
                </span>
              </h1>

              <hr v-if="hasValue18 || hasValue19 || hasValue19 || hasValue20 || hasValue21 || hasValue22 || hasValue23 || hasValue24 || hasValue25" />

              <ul class="list-unstyled d-flex socks flex-wrap">
                <li class="d-flex flex-column" v-if="hasValue18">
                  <img :src="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Icon18')" class="sockenicons mx-auto" :alt="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text18')" />
                  <p class="mb-0 text-center" v-html="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text18')"></p>
                </li>
                <li class="d-flex flex-column" v-if="hasValue19">
                  <img :src="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Icon19')" class="sockenicons mx-auto" :alt="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text19')" />
                  <p class="mb-0 text-center" v-html="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text19')"></p>
                </li>
                <li class="d-flex flex-column" v-if="hasValue20">
                  <img :src="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Icon20')" class="sockenicons mx-auto" :alt="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text20')" />
                  <p class="mb-0 text-center" v-html="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text20')"></p>
                </li>
                <li class="d-flex flex-column" v-if="hasValue21">
                  <img :src="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Icon21')" class="sockenicons mx-auto" :alt="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text21')" />
                  <p class="mb-0 text-center" v-html="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text21')"></p>
                </li>
                <li class="d-flex flex-column" v-if="hasValue22">
                  <img :src="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Icon22')" class="sockenicons mx-auto" :alt="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text22')" />
                  <p class="mb-0 text-center" v-html="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text22')"></p>
                </li>
                <li class="d-flex flex-column" v-if="hasValue23">
                  <img :src="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Icon23')" class="sockenicons mx-auto" :alt="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text23')" />
                  <p class="mb-0 text-center" v-html="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text23')"></p>
                </li>
                <li class="d-flex flex-column" v-if="hasValue24">
                  <img :src="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Icon24')" class="sockenicons mx-auto" :alt="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text24')" />
                  <p class="mb-0 text-center" v-html="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text24')"></p>
                </li>
                <li class="d-flex flex-column" v-if="hasValue25">
                  <img :src="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Icon25')" class="sockenicons mx-auto" :alt="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text25')" />
                  <p class="mb-0 text-center" v-html="$translate('sockenrauschVueTheme::SingleItemSockenIcons.Text25')"></p>
                </li>
              </ul>
              <hr />
              <div class="d-none">
                <slot name="tag-list"></slot>
              </div>

              <!-- Variation -->
              <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                <variation-select></variation-select>
              </div>
              <!-- /Variation -->

              <slot name="before-price"></slot>

              <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                <order-property-list></order-property-list>
              </div>

              <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

              <slot name="after-price"></slot>

              <slot name="additional-content-after-vat"></slot>

              <div class="fs-availability">
                <item-availability></item-availability>
              </div>

              <div class="free-socks d-flex d-md-none p-2" v-if="hasProp377Socks">
                <slot name="free-socks"></slot>
              </div>

              <div class="mt-3 mb-4 fs-addtobasket">
                <div class="w-100">
                  <slot name="before-add-to-basket"></slot>
                </div>

                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                  {{ $translate("Ceres::Template.singleItemSetInfo") }}
                </div>
                <div v-else class="col-12 col-sm-7 col-md-12 my-3 px-0">
                  <add-to-basket
                    :variation-id="currentVariation.variation.id"
                    :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                    :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                    :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                    :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                    :maximum-quantity="
                      !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                    "
                    :order-properties="
                      currentVariation.properties.filter(function(prop) {
                        return prop.property.isOderProperty;
                      })
                    "
                    :has-order-properties="currentVariation.hasOrderProperties"
                    :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                    :use-large-scale="false"
                    :show-quantity="true"
                    :item-url="currentVariation | itemURL"
                    :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                    :has-price="currentVariation | hasItemDefaultPrice"
                  >
                  </add-to-basket>
                </div>

                <div class="w-100 ppbtn">
                  <slot name="after-add-to-basket"></slot>
                </div>

                <ul class="list-unstyled d-flex flex-wrap mt-4">
                  <li class="w-100 mb-3" v-if="$translate('sockenrauschVueTheme::SingleItemUSPs.USP1ImgUrl') != ''">
                    <a :href="$translate('sockenrauschVueTheme::SingleItemUSPs.USP1LinkTo')" class="d-flex align-items-center">
                      <img :src="$translate('sockenrauschVueTheme::SingleItemUSPs.USP1ImgUrl')" class="img-fluid mr-3" :alt="$translate('sockenrauschVueTheme::SingleItemUSPs.USP1Headline')" />
                      <p class="mb-0 text-muted">{{ $translate("sockenrauschVueTheme::SingleItemUSPs.USP1Headline") }}</p>
                    </a>
                  </li>

                  <li class="w-100 mb-3" v-if="$translate('sockenrauschVueTheme::SingleItemUSPs.USP2ImgUrl') != ''">
                    <a :href="$translate('sockenrauschVueTheme::SingleItemUSPs.USP2LinkTo')" class="d-flex align-items-center">
                      <img :src="$translate('sockenrauschVueTheme::SingleItemUSPs.USP2ImgUrl')" class="img-fluid mr-3" :alt="$translate('sockenrauschVueTheme::SingleItemUSPs.USP2Headline')" />
                      <p class="mb-0 text-muted">{{ $translate("sockenrauschVueTheme::SingleItemUSPs.USP2Headline") }}</p>
                    </a>
                  </li>

                  <li class="w-100 mb-3" v-if="$translate('sockenrauschVueTheme::SingleItemUSPs.USP3ImgUrl') != ''">
                    <a :href="$translate('sockenrauschVueTheme::SingleItemUSPs.USP3LinkTo')" class="d-flex align-items-center">
                      <img :src="$translate('sockenrauschVueTheme::SingleItemUSPs.USP3ImgUrl')" class="img-fluid mr-3" :alt="$translate('sockenrauschVueTheme::SingleItemUSPs.USP3Headline')" />
                      <p class="mb-0 text-muted">{{ $translate("sockenrauschVueTheme::SingleItemUSPs.USP3Headline") }}</p>
                    </a>
                  </li>

                  <li class="w-100 mb-3" v-if="$translate('sockenrauschVueTheme::SingleItemUSPs.USP4ImgUrl') != ''">
                    <a :href="$translate('sockenrauschVueTheme::SingleItemUSPs.USP4LinkTo')" class="d-flex align-items-center">
                      <img :src="$translate('sockenrauschVueTheme::SingleItemUSPs.USP4ImgUrl')" class="img-fluid mr-3" :alt="$translate('sockenrauschVueTheme::SingleItemUSPs.USP4Headline')" />
                      <p class="mb-0 text-muted">{{ $translate("sockenrauschVueTheme::SingleItemUSPs.USP4Headline") }}</p>
                    </a>
                  </li>

                  <li class="w-100 mb-3" v-if="$translate('sockenrauschVueTheme::SingleItemUSPs.USP5ImgUrl') != ''">
                    <a :href="$translate('sockenrauschVueTheme::SingleItemUSPs.USP5LinkTo')" class="d-flex align-items-center">
                      <img :src="$translate('sockenrauschVueTheme::SingleItemUSPs.USP5ImgUrl')" class="img-fluid mr-3" :alt="$translate('sockenrauschVueTheme::SingleItemUSPs.USP5Headline')" />
                      <p class="mb-0 text-muted">{{ $translate("sockenrauschVueTheme::SingleItemUSPs.USP5Headline") }}</p>
                    </a>
                  </li>
                </ul>
              </div>

              <!-- ./ITEM DETAIL -->
              <slot name="additional-content-after-add-to-basket"></slot>
              <!-- END SINGLEITEM_DETAILS -->
            </div>
          </div>

          <div class="col-12 col-md-6">
            <p class="h3">{{ $translate("sockenrauschVueTheme::SingleItem.DescriptionHeadline") }}</p>
            <div class="my-4" v-html="currentVariation.texts.description"></div>

            <div class="eu-responsible small">
              <p class="h4">{{ $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</p>
              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                  {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                </span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
              </div>
            </div>
            <div class="eu-responsible small mt-4">
              <p class="h4">{{ $translate("Ceres::Template.singleItemManufacturer") }}</p>
              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.name }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.legalName }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.street }}</span>
                <span>{{ currentVariation.item.manufacturer.houseNo }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.postcode }}</span>
                <span>{{ currentVariation.item.manufacturer.town }}</span>
                <span v-if="currentVariation.item.manufacturer.countryObject">
                  {{ currentVariation.item.manufacturer.countryObject.name }}
                </span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.email }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.url }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.phoneNumber }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.faxNumber }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.contactUrl }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="item-data-container mb-5 mb-md-0">
              <p class="h3">{{ $translate("sockenrauschVueTheme::SingleItem.TechnicalDataHeadline") }}</p>
              <div class="item-data">
                <div v-html="currentVariation.texts.technicalData"></div>
              </div>
              <div class="mt-3 text-center">
                <a
                  class="d-inline-block text-muted text-center p-2 btn-more"
                  href="#"
                  onclick="event.preventDefault(); document.getElementsByClassName('item-data-container')[0].classList.toggle('show');"
                >
                  <span class="font-weight-bold show-more">{{ $translate("sockenrauschVueTheme::SingleItem.ShowMore") }}</span>
                  <span class="font-weight-bold show-less">{{ $translate("sockenrauschVueTheme::SingleItem.ShowLess") }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="single container-max page-content">
        <div class="row cross-selling">
          <slot name="cross-selling-accessory"></slot>
          <slot name="cross-selling-similar"></slot>
          <slot name="feedback-container"></slot>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  computed: {
    itemConfig() {
      return App.config.item.itemData;
    },

    hasValue18() {
      return this.checkValue(18);
    },
    hasValue19() {
      return this.checkValue(19);
    },
    hasValue20() {
      return this.checkValue(20);
    },
    hasValue21() {
      return this.checkValue(21);
    },
    hasValue22() {
      return this.checkValue(22);
    },
    hasValue23() {
      return this.checkValue(23);
    },
    hasValue24() {
      return this.checkValue(24);
    },
    hasValue25() {
      return this.checkValue(25);
    },

    hasProp377Socks() {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 377 && property.values.selectionId == 36) {
              return true;
            }
          }
        }
        return false;
      }
      return false;
    },

    hasSizeCategoryId() {
      return App.themeConfig.hasSizeCategoryId > 0;
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },

    isManufacturerTabShown() {
      return (
        this.currentVariation.item.manufacturer.url !== "" ||
        this.currentVariation.item.manufacturer.street !== "" ||
        this.currentVariation.item.manufacturer.houseNo !== "" ||
        this.currentVariation.item.manufacturer.postcode !== "" ||
        this.currentVariation.item.manufacturer.town !== "" ||
        this.currentVariation.item.manufacturer.countryId !== 0 ||
        this.currentVariation.item.manufacturer.phoneNumber !== "" ||
        this.currentVariation.item.manufacturer.faxNumber !== "" ||
        this.currentVariation.item.manufacturer.email !== "" ||
        this.currentVariation.item.manufacturer.legalName !== "" ||
        this.currentVariation.item.manufacturer.contactUrl !== "" ||
        this.currentVariation.item.manufacturer.name !== ""
      );
    },
    isEuResponsibleTabShown() {
      return (
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleContactUrl !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },

    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  methods: {
    checkValue(value) {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 374) {
              for (let vvalues of property.values) {
                if (vvalues.selectionId == value) {
                  return true;
                }
              }
              return false;
            } else {
              return false;
            }
          }
        }
        return false;
      }
      return false;
    },

    randomItem(items) {
      return items[Math.floor(Math.random() * items.length)];
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },
};
</script>
